module.exports = __webpack_public_path__ + "img/20220815160511.f59afc1f.png";